import { apiClient } from './client';

/**
 * 대화방 꾸미기 (chat-room-styles — 2026-08-26).
 *
 * 앱은 이 설정을 **기기 안에만** 두어 폰끼리도 안 따라간다. 서버에 두면 기기를 옮겨도 같은 방이
 * 같은 모습으로 열린다. 값은 방장이 아니라 **각자 자기 화면**의 것이다.
 */

export interface RoomStyle {
  roomId: string;
  backgroundId: string | null;
  accentId: string | null;
}

export async function listRoomStyles(): Promise<RoomStyle[]> {
  const { data } = await apiClient.get<{ styles: RoomStyle[] }>('/chat/room-styles');
  return data.styles ?? [];
}

/** 둘 다 기본이면 서버가 행을 지운다(기본값을 저장해 두지 않는다). */
export async function saveRoomStyle(
  roomId: string, input: { backgroundId?: string | null; accentId?: string | null },
): Promise<RoomStyle | null> {
  const { data } = await apiClient.put<{ style: RoomStyle | null }>(
    `/chat/room-styles/${roomId}`, input,
  );
  return data.style ?? null;
}
